// extracted by mini-css-extract-plugin
module.exports = {"about-us":"sustainablity_about-us__2j8BJ","bg":"sustainablity_bg__37SaW","subHeader":"sustainablity_subHeader__1kRCx","detail":"sustainablity_detail__2NjwV"};